import * as React from 'react';
import * as H from 'history';
import { match } from 'react-router';
import { inject, observer } from 'mobx-react';
import { Link } from 'react-router-dom';
import { IAppOnlyStore } from './../../../stores/AllStores';

// Styles
const s = require('./403.css');

// Props
interface IAppForbidden extends IAppOnlyStore {
    readonly history: H.History;
    readonly location: H.Location;
    readonly match: match<any>;
}

// Component
@inject('store')
@observer
export class PageForbidden extends React.Component<IAppForbidden, {}> {
    constructor(props) {
        super(props);
    }

    private handleBackNavigation = (e: React.MouseEvent<HTMLAnchorElement>) => {
        e.preventDefault();
        this.props.history.goBack();
    };

    private handleLoginClick = () => {
        this.props.store.user.logout();
    };

    public render() {
        return (
            <div className={s.container}>
                <div className={s.error}>

                    <h1>Page not allowed</h1>

                    <div className={s.buttons}>
                        <a href="#go-back" onClick={this.handleBackNavigation}>Go back</a>
                        <Link to={{
                                    pathname: `/user/login`,
                                    state: {
                                        from: this.props.location.pathname
                                }}}
                                onClick={this.handleLoginClick}>
                            Go to login
                        </Link>
                    </div>

                </div>
            </div>
        );
    }
}

export default PageForbidden;



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--0!./app/web/src/routes/errors/403-forbidden/403.tsx